import React, {useRef, useState, useEffect} from 'react';
import * as classes from './Panel.module.scss'

import { getFileName } from '../../../../helpers/FileCatching';

const globalImages = require.context('../../../../images', true, /.*\.(gif|png|jpe?g|svg)$/i);
const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Panel({content, active, onClosed}) {

    let panelContainer = useRef()

    let defaultClasses = (onClosed ? `${classes.Panel} ${(active ? classes.PanelActive : "")}` : `${classes.Panel} ${classes.PanelCarousel}`)

    let panelContent =             
        <>
            <a href={content.lernMoreUrl} style={{pointerEvents:(!active ? "none" : "all")}} target="_self">
                <img src={getFileName(contentImages, content.image).default} alt={content.imageAlt}></img>
                <div className={classes.Panel__copyContainer}>
                    <h3 className="promoHeading">{content.location}</h3>
                    <h2 className="promoTitle">{content.title}</h2>
                </div>
            </a>
            {
                (
                    onClosed 
                    ?
                    <div className={classes.Panel__close} onClick={() => {close() }}><img src={getFileName(globalImages,'+.svg').default} alt={'Close'}/></div> 
                    :
                    ""
                )
            }
        </>

    function close(){
        onClosed()
    }

    return (
        <div ref={panelContainer} className={defaultClasses}>
            {panelContent}
        </div>
    );
}

export default Panel;